import { isWithinInterval, parseISO } from 'date-fns';
import { ISubsidyBanner } from '../../interfaces/Banner.interfaces';

export const BANNER_LIST: ISubsidyBanner[] = [
  {
    id: 'banner_001',
    showBanner: true,
    startDate: '2026-02-01',
    endDate: '2026-02-20',
    displayIndex: 0,
    targetCategories: ['전체', '시설', '과수·원예', '유통·판매'],
    categoryLabel: '저온저장고',
    title: '보조금 300만원 신청하기!',
    bgColor: '#4A61FF',
    icon: 'Snowflake',
    showDetailBtn: true,
    detailBtnText: '가이드 읽기',
    linkUrl: '/info/6feef290-f50c-4d6d-99cb-761022aecb9c',
  },
];

export const getActiveBanners = (categories: string[]) => {
  const now = new Date();
  return BANNER_LIST.filter((banner) => {
    const isVisible =
      banner.showBanner &&
      isWithinInterval(now, {
        start: parseISO(banner.startDate),
        end: parseISO(banner.endDate),
      });

    // logic:
    // 1. If 'all' is included, show in all category tabs.
    // 2. If any of the selected categories matches one of entries in targetCategories, show it.
    const isCategoryMatch =
      banner.targetCategories.includes('all') || categories.some((cat) => banner.targetCategories.includes(cat));

    return isVisible && isCategoryMatch;
  });
};
